import React, { useState, useEffect, Fragment } from 'react';
import services from '../../services';
import MessageModal from '../../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { CommonDecryptParam } from '../../../../../utils/CommonParams';
import FormHelperText from '@material-ui/core/FormHelperText';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import messageModal from '../../../../UI/Modal/MessageModal';
import { generateStatus } from '../../satusGenerator';
import tokenDecoder from '../../../../Common/tokenDecoder';

const screenCode = 'PURCHASEORDER';

export function ApproveSupplierAddEdit(props) {

    const [orderDetails, setOrderDetails] = useState([]);
    const [itemDetails, setItemDetails] = useState([]);
    const [isSupplierItemsRejected, setIsSupplierItemsRejected] = useState(0);
    const [rejectItemData, setRejectItemData] = useState([]);
    const [rejectType, setRejectType] = useState(0);
    const [isClicked, setIsClicked] = useState(false);
    const [approveSuppliers, setApproveSuppliers] = useState({
        groupID: '0',
        operationEntityID: '0',
        orderID: '0',
        collectionTypeID: '0',
        customerID: '0',
        rejectReason: ''
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [openDialog, setOpenDialog] = React.useState(false);
    const [supplieritems, setSupplierItems] = useState([]);
    const [selectedReject, setSelectedReject] = useState({});
    const encriptedText = props.match.params["id"];
    const id = (encriptedText !== undefined) ? CommonDecryptParam(encriptedText) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const tableHeaderStyle = {
        color: "#263238",
        textTransform: "uppercase",
        fontSize: "12px",
        fontWeight: "bold"
    }
    const subTableHeaders = {
        textTransform: "uppercase",
        fontSize: "12px"
    }

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        if (messageModel.hidden === false) {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 2000);
        }
    }, [messageModel])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDSUPPLIERVERIFY');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            trackPromise(
                setScreenData()
            )
        }
    }

    async function setScreenData() {
        var result = await services.getOrderDetailsForApproveSupplierScreen(id);
        setOrderDetails(result.order);

        setSupplierItems(result.supplierOrderItems);

        var items = [];
        var supplierItemRejectCount = 0;

        result.orderItems.forEach(x => {
            var supplierItems = [];

            result.supplierOrderItems.forEach(r => {
                if (r.orderItemID === x.orderItemID) {

                    if (r.statusTypeID === 7)
                        supplierItemRejectCount ++;

                    supplierItems.push({
                        supplierOrderItemsID: r.supplierOrderItemsID,
                        orderItemID: r.orderItemID,
                        customerID: r.customerID,
                        supplierName: r.firstName,
                        unitPrice: r.unitPrice,
                        totalPrice: r.totalPrice,
                        supplingQauntity: r.supplingQauntity,
                        lastUnitPrice: r.lastUnitPrice,
                        statusType: r.statusTypeID,
                        rejectReason: r.rejectReason,
                        version: r.version
                    })
                }
            })

            items.push(
                createData(
                    x.orderItemID,
                    x.collectionTypeName,
                    x.collectionTypeID,
                    x.itemQuantity,
                    x.measuringUnit,
                    x.state,
                    x.remQty,
                    supplierItems
                )
            );

        });

        setItemDetails(items);
        setIsSupplierItemsRejected(supplierItemRejectCount);

        setApproveSuppliers({
            ...approveSuppliers,
            groupID: result.order.groupID,
            operationEntityID: result.order.operationEntityID,
            orderID: result.order.orderID
        });
    }

    function handleChange(target) {
        setApproveSuppliers({
            ...approveSuppliers,
            rejectReason: target.value
        });
    }

    async function handleSave(e) {
        e.preventDefault()

        var isRejectedItemCount = 0;

        itemDetails.forEach(x => {
            x.supplierItems.forEach(y => {
                if (y.statusType === 7) {
                    isRejectedItemCount++;
                }
            })
        })

        if (isRejectedItemCount > 0) {
            setMessageModel({ ...messageModel, hidden: false, type: "Warning", disciption: "Cannot approve rejected items." });
        } else {
            setIsClicked(true);

            // var supplierItemsIds = [];

            // itemDetails.forEach(x => {
            //     x.supplierItems.forEach(y => {
            //         supplierItemsIds.push(
            //             {
            //                 supplierOrderItems: y.supplierOrderItemsID,
            //                 version: y.version
            //             }
            //         );
            //     });
            // });
            let SupOrderItemModelsArray = [];
            itemDetails.forEach(x => {

                let SupOrderItemDetailModelsArray = [];

                x.supplierItems.forEach(s => {

                    let supDetailModel = {
                     supplierOrderItemID : s.supplierOrderItemsID,
                     supplierName  :s.supplierName,
                     qty :s.supplingQauntity,
                     unitPrice  :s.unitPrice,
                     lastUnitPrice  :s.lastUnitPrice,
                     totalPrice : s.totalPrice,
                     status  : generateStatus(s.statusType),
                     rejectReason :s.rejectReason,
                     version  :s.version,
                    }
                    SupOrderItemDetailModelsArray.push(supDetailModel);
    
                 });

                var SupOrderItemModel={
                    itemName:x.collectionTypeName ,  
                    totalQty :x.itemQuantity ,
                    remQty :x.measuringUnit ,
                    totPrice : parseFloat(totalCalValue(x)),
                    measuringUnit :x.measuringUnit ,
                    supOrderRequestDetailModels :SupOrderItemDetailModelsArray
                }
                SupOrderItemModelsArray.push(SupOrderItemModel);
        
               

              

            });
            var datamodel = {
                orderNumber:orderDetails.orderNumber,
                date :new Date().toISOString().split('T')[0],
                buyerName: orderDetails.buyerName,
                groupID: approveSuppliers.groupID,
                operationEntityID : approveSuppliers.operationEntityID,
                modifiedBy : parseInt(tokenDecoder.getUserIDFromToken()),
                supOrderItemModels:SupOrderItemModelsArray
            }
            
          
     
            const response = await services.saveApproveStatus(datamodel);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);

            setIsClicked(false);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/PurchaseAdvice' })
            }, 1500);
        }
    }

    function roundNumber(num) {
        return (Math.round(num * 100) / 100).toFixed(2);
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setApproveSuppliers({
            ...approveSuppliers,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntity,
            orderNumber: '',
            buyerID: '0',
            invoiceDate: new Date().toISOString().split('T')[0],
            dueDate: new Date().toISOString().split('T')[0],
            collectionTypeID: '0',
            itemQuantity: '',
            measuringUnit: ''
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function onRejectClick() {
        setRejectType(0);
        handleClickOpen();
    }

    async function handleReject() {
        if (approveSuppliers.rejectReason.trim().length === 0) {
            setErrors({
                ...errors,
                rejectReason: "Please enter reject reason."
            });
            return;
        } else {
            clearErrorMessage();
            setOpenDialog(false);

            if (rejectType === 0) {
                const response = await services.rejectAllSupplierItems(approveSuppliers.rejectReason, supplieritems);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

                setScreenData();

                if (supplieritems.length === response.data)
                    afterSuccessfulyChanged(response.statusCode);

            } 
            else {

                let SupOrderItemDetailModelsArray = [];
                var itemData = rejectItemData;
                var rowData = selectedReject;
                // rowData.supplierItems.forEach(s => {
                let supDetailModel = {
                    SupplierOrderItemID: itemData.supplierOrderItemsID,
                    SupplierName: itemData.supplierName,
                    Qty: itemData.supplingQauntity,
                    UnitPrice: itemData.unitPrice,
                    LastUnitPrice: itemData.lastUnitPrice,
                    TotalPrice: itemData.totalPrice,
                    Status: generateStatus(itemData.statusType),
                    RejectReason: itemData.rejectReason,
                    Version: itemData.version,
                }
                SupOrderItemDetailModelsArray.push(supDetailModel);
                // });


                let SupOrderItemModelsArray = [];

                var SupOrderItemModel = {
                    itemName: rowData.collectionTypeName,
                    totalQty: rowData.itemQuantity,
                    remQty: rowData.measuringUnit,
                    totPrice: parseFloat(totalCalValue(rowData)),
                    measuringUnit: rowData.measuringUnit,
                    supOrderRequestDetailModels: SupOrderItemDetailModelsArray
                }
                SupOrderItemModelsArray.push(SupOrderItemModel);

                var datamodel = {
                    orderNumber: orderDetails.orderNumber,
                    date: new Date().toISOString().split('T')[0],
                    buyerName: orderDetails.buyerName,
                    groupID: approveSuppliers.groupID,
                    operationEntityID: approveSuppliers.operationEntityID,
                    modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
                    supOrderItemModels: SupOrderItemModelsArray
                }


                var response = await services.rejectSelectedSupplierOrderItem(approveSuppliers.rejectReason, rejectItemData,datamodel);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

                var result = await services.getOrderDetailsForApproveSupplierScreen(id);

                if (result.supplierOrderItems.length <= 0) {
                    afterSuccessfulyChanged("Success");
                }

                setScreenData();
                setDailogBoxEmpty();
            }
        }
    }

    function setDailogBoxEmpty() {
        setApproveSuppliers({
            ...approveSuppliers,
            rejectReason: ''
        })
    }

    function handleClickOpen(row) {
        setSelectedReject(row)
        setOpenDialog(true);
    };

    const handleClose = () => {
        clearErrorMessage();
        setDailogBoxEmpty();
        setOpenDialog(false);
    };

    function clearErrorMessage() {
        const error = { ...errors }
        delete error["rejectReason"]
        setErrors(error);
    }

    function createData(orderItemID, collectionTypeName, collectionTypeID, itemQuantity,
        measuringUnit, state, remQty, supplierItems) {
        return {
            orderItemID,
            collectionTypeName,
            collectionTypeID,
            itemQuantity,
            measuringUnit,
            state,
            remQty,
            supplierItems
        };
    }

    async function handleItemRejectClick(rowData, itemData) {
        setRejectType(1);
        setRejectItemData(itemData);
        handleClickOpen(rowData);
    }

    async function handleItemApproveClick(rowData, itemData) {


        let SupOrderItemDetailModelsArray = [];

       // rowData.supplierItems.forEach(s => {
           let supDetailModel = {
            SupplierOrderItemID : itemData.supplierOrderItemsID,
            SupplierName  :itemData.supplierName,
            Qty :itemData.supplingQauntity,
            UnitPrice  :itemData.unitPrice,
            LastUnitPrice  :itemData.lastUnitPrice,
            TotalPrice : itemData.totalPrice,
            Status  : generateStatus(itemData.statusType),
            RejectReason :itemData.rejectReason,
            Version  :itemData.version,
           }
           SupOrderItemDetailModelsArray.push(supDetailModel);
       // });


        let SupOrderItemModelsArray = [];

        var SupOrderItemModel={
            itemName:rowData.collectionTypeName ,  
            totalQty :rowData.itemQuantity ,
            remQty :rowData.measuringUnit ,
            totPrice : parseFloat(totalCalValue(rowData)),
            measuringUnit :rowData.measuringUnit ,
            supOrderRequestDetailModels :SupOrderItemDetailModelsArray
        }
        SupOrderItemModelsArray.push(SupOrderItemModel);

        var datamodel = {
            orderNumber:orderDetails.orderNumber,
            date :new Date().toISOString().split('T')[0],
            buyerName: orderDetails.buyerName,
            groupID: approveSuppliers.groupID,
            operationEntityID : approveSuppliers.operationEntityID,
            modifiedBy : parseInt(tokenDecoder.getUserIDFromToken()),
            supOrderItemModels:SupOrderItemModelsArray
        }


        var response = await services.approveSelectedSupplierOrderItem(datamodel);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

        if (response.statusCode === "Success") {
            setScreenData();

            var count = 0;            
            itemDetails[0].supplierItems.forEach(x => {
                if (x.statusType === 1)
                    count = count + 1
            });

            if (count <= 1) {
                afterSuccessfulyChanged("Success");
            }
        } else {
            setScreenData();
        }
    }

    function totalCal(row) {
        var tot = 0;

        row.supplierItems.forEach(s => {
            if (row.orderItemID === s.orderItemID && (s.statusType !== 7 && s.statusType !== 9)) {
                tot = tot + parseFloat(s.totalPrice);
            }
        });

        return (
            <div>{roundNumber(parseFloat(tot))}</div>
        )
    }

    function totalCalValue(row) {
        var tot = 0;

        row.supplierItems.forEach(s => {
            if (row.orderItemID === s.orderItemID && (s.statusType !== 7 && s.statusType !== 9)) {
                tot = tot + parseFloat(s.totalPrice);
            }
        });

        return roundNumber(parseFloat(tot));
    }

    function totalQuantity(row) {
        var tot = 0;

        row.supplierItems.forEach(s => {
            if (row.orderItemID === s.orderItemID && (s.statusType !== 7 && s.statusType !== 9)) {
                tot = tot + parseInt(s.supplingQauntity);
            }
        });

        return (
            <div>{tot}</div>
        )
    }

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(true);
        const classes = useRowStyles();

        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.collectionTypeName}
                    </TableCell>
                    <TableCell align="right">{row.itemQuantity}</TableCell>
                    <TableCell align="right">
                        {
                            row.remQty
                        }
                    </TableCell>
                    <TableCell align="right">{totalCal(row)}</TableCell>
                    <TableCell align="right" component="th" scope="row">
                        {row.measuringUnit === 1 ? "Kg" : "Unit"}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "#FAFAFA" }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {row.supplierItems.length !== 0 ? <Box marginLeft={20}>
                                <Typography variant="body2" gutterBottom component="div">
                                    Supplier Details
                                </Typography>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={subTableHeaders}><b>Supplier</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Quantity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Last Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Total price (LKR.)</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Status</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Reject Reason</b></TableCell>
                                            <TableCell align="center" style={subTableHeaders}><b>Action</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.supplierItems.map((itemData, i) => {
                                            return (
                                                <TableRow key={i} style={(itemData.statusType === 7 || itemData.statusType === 9) ? { backgroundColor: "#FFEBEE" } : null}>
                                                    <TableCell component="th" scope="row">
                                                        {itemData.supplierName}
                                                    </TableCell>
                                                    <TableCell align="right">{itemData.supplingQauntity}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.unitPrice)}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.lastUnitPrice)}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.totalPrice)}</TableCell>
                                                    <TableCell align="right">
                                                        {
                                                            generateStatus(itemData.statusType)
                                                        }
                                                    </TableCell>
                                                    <TableCell align="right">{itemData.rejectReason}</TableCell>
                                                    <TableCell align="center">
                                                        {itemData.statusType !== 7 ?
                                                            <div>
                                                                <i
                                                                    style={{ cursor: "pointer" }}
                                                                    className="far fa-check-circle pr-3"
                                                                    onClick={() => trackPromise(handleItemApproveClick(row, itemData))}
                                                                />
                                                                <i
                                                                    style={{ cursor: "pointer" }}
                                                                    className="far fa-times-circle"
                                                                    onClick={() => trackPromise(handleItemRejectClick(row, itemData))}
                                                                />
                                                            </div> :
                                                            null}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box> : <p style={{ fontSize: "14px" }}>No Data.</p>}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Approve Supplier"
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/PurchaseAdvice"
                        />
                        <hr />
                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col"><p style={{ fontSize: "14px" }}>
                                        <b>Order Number: </b> {orderDetails.orderNumber}</p>
                                    </div>
                                    <div className="col"><p style={{ fontSize: "14px", textAlign: "center" }}>
                                        <b>Date: </b>{new Date().toISOString().split('T')[0]}</p>
                                    </div>
                                    <div className="col"><p style={{ fontSize: "14px", float: "right" }}>
                                        <b>Buyer: </b>{orderDetails.buyerName}</p>
                                    </div>
                                </div>
                                <Dialog open={openDialog} onClose={handleClose}
                                    aria-labelledby="form-dialog-title">
                                    <DialogTitle id="form-dialog-title">Reject Reason</DialogTitle>
                                    <DialogContent>
                                        <TextareaAutosize
                                            id="rejectReason"
                                            rowsMin={5}
                                            onChange={(e) => handleChange(e.target)}
                                            value={approveSuppliers.rejectReason}
                                        />
                                        {errors["rejectReason"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["rejectReason"]}</FormHelperText>}
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            Cancel
                                        </Button>
                                        <Button onClick={handleReject} color="primary">
                                            Confirm
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <div className="row">
                                    <div className="col">
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table">
                                                <TableHead style={{ backgroundColor: "White" }}>
                                                    <TableRow>
                                                        <TableCell />
                                                        <TableCell style={tableHeaderStyle}>Item Name</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Total Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Remaining Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Total Price (LKR.)</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Measuring Unit</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {itemDetails.map((row, i) => {
                                                        return (
                                                            row.supplierItems.length === 0 ? null : <Row key={i} row={row} />
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <input
                                    disabled={isSupplierItemsRejected > 0}
                                    type="submit"
                                    className="btn btn-primary"
                                    value="Approve All"
                                />
                                <input
                                    type="button"
                                    className="btn btn-warning pull-right"
                                    value="Reject All"
                                    onClick={onRejectClick}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}
